module.exports = __webpack_public_path__ + "static/pictop-c82e42512386971d388d4f0b91a0eb19.png";